const pathnameIncludesOne = (...pathParams) => {
  return traffic => {
    const urlObject = new URL(traffic.url.toLowerCase())
    const pathParts = urlObject.pathname.split('/')
    return pathParams.some(pathParam => pathParts.includes(pathParam))
  }
}

export default pathnameIncludesOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/pathnameIncludesOne.js